import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { push as routerPush } from 'react-router-redux';
import moment from 'moment';
import { FontIcon, Avatar, FlatButton } from 'material-ui';
import TextField from 'material-ui/TextField';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import TimeLapseIcon from 'material-ui/svg-icons/image/timelapse';
import LoadingOverlay from '../../tc-ui/loading-overlay';
import Chip from 'material-ui/Chip';
import pluralize from 'pluralize';
import injectSheet from './body.css.js';
import { styles } from './body.css.js';

import Pagination from '../../tc-ui/pagination/pagination';
import { fileUrls } from '../../../api';
const eventPriority = {
  null: -1,
  processing: 0,
  redirected: 0,
  processed: 1,
  deferred: 2,
  dropped: 3,
  bounced: 4,
  delivered: 5,
  open: 6,
  click: 7,
};
class massMessagingBody extends React.Component {
  state = {
    partnerFilter: '',
    currentPage: 1,
  };
  shouldComponentUpdate(nextProps, nextState) {
    const retVal = (this.state.partnerFilter !== nextState.partnerFilter) ||
    (this.state.currentPage !== nextState.currentPage) ||
    (this.props.conversationsFetching !== nextProps.conversationsFetching); // stops the flickering while switching bulkMessage
    return retVal;
  }
  _updateValue(type) {
    this.setState({ [type]: this.refs[type].getValue() });
  }
  _handleFileClick(path) {
    window.open(fileUrls.getDownloadUrlSync(path));
  }
  switchPage = (newPage) => {
    this.setState({ currentPage: newPage });
  }
  render() {
    const { partnerFilter, currentPage } = this.state;
    const { classes, title, bulkMessage, conversationsFetching, selectedChannel } = this.props;
    const { recipients, stats, subject, body, attachments = [] } = bulkMessage;
    let sentData = null;
    if (bulkMessage.sentAt) {
      sentData = `Sent on ${moment(bulkMessage.sentAt).format('MMM DD YYYY [at] h:mma')}`;
      if (bulkMessage.sentBy) {
        const { sentBy } = bulkMessage;
        const author = sentBy.name || sentBy.email;
        sentData += ` by ${author}`;
      }
    }
    const recipientsFormatted = (recipients || []).map(e => { // build searchable text fields
      const contactReduced = (e.to || []).reduce((prev, curr) => {
        return (`${prev} ${curr.firstName || ''} ${curr.last_name || ''}`);
      }, '');
      return { ...e, searchText: `${(e.partnerName)} ${contactReduced}`.replace(/ {2}/g, ' ') };
    }).filter(e => { // search using a broad match consider spaces as wildcards
      if (partnerFilter.trim().length < 1) return true;
      return new RegExp(`^.*${partnerFilter.split(' ').join('.*')}.*$`, 'gi').test(e.searchText);
    }).map(recipient => {
      const retVal = {
        avatarText: recipient.partnerAvatar ? undefined : (recipient.partnerName || recipient.email)[0].toUpperCase(),
        to: recipient.to || [],
      };
      return ({ ...recipient, ...retVal });// extend the object with changes
    });
    const icons = {
      'open': (className) => (<FontIcon className={`tc-icon-email-open-outline ${classes[className] || ''}`} />),
      'click': (className) => (<FontIcon className={`tc-icon-checkbox-marked-circle ${classes[className] || ''}`} />),
      'delivered': (className) => (<FontIcon className={`tc-icon-email-outline ${classes[className] || ''}`} />),
      'redirected': (className) => (<FontIcon className={`tc-icon-email ${classes[className] || ''}`} />),
      'bounce': (className) => (<FontIcon className={`tc-icon-error ${classes[className] || ''}`} />),
      'bounced': (className) => (<FontIcon className={`tc-icon-error ${classes[className] || ''}`} />),
      'dropped': (className) => (<FontIcon className={`tc-icon-error ${classes[className] || ''}`} />),
      'spam report': (className) => (<FontIcon className={`tc-icon-error ${classes[className] || ''}`} />),
      'processed': (className) => (<FontIcon className={`tc-icon-paperplane ${classes[className] || ''}`} />),
      'deferred': (className) => (<FontIcon className={`tc-icon-paperplane ${classes[className] || ''}`} />),
      'processing': (className) => (<TimeLapseIcon style={{ ...styles[className], width: styles[className].svgSize, height: styles[className].svgSize }}/>),
      'notified in system': (className) => (<TimeLapseIcon style={{ ...styles[className], width: styles[className].svgSize, height: styles[className].svgSize }}/>),
    };
    // fontSize: classes..fontSize
    const txtReplace = {
      'open': 'opened',
      'click': 'clicked',
    };
    const onClickResend = () => this.props.resendBulkMessage({
      bulkMessageId: bulkMessage.bulkMessageId,
      companyId: bulkMessage.owner,
    });
    return (
      <div className={classes.main}>
        <div className={classes.title}>{title}&nbsp;</div>
        <div className={`${classes.body}${conversationsFetching ? ` ${classes.semitransparent}` : ''}${selectedChannel ? '' : ` ${classes.hidden}`}`}>
          <div className={classes.sentData}>
            {(sentData) ? <span>{sentData}</span> : <span>Not sent yet</span>}
            {
              Boolean(this.props.isAnAdmin) && (
                <FlatButton
                  primary
                  label="Resend (Admin Only)"
                  onTouchTap={onClickResend}
                  size="small"
                />
              )
            }
          </div>
          <Card className={classes.firstCard}>
            <CardHeader
              className={classes.headerContainer}
              title={<div className={classes.cardHeader}>
                <div className={classes.flexItem}>
                  {/* <div><FontIcon className={`tc-icon-check_circle2 ${classes.headerIcon}`} /></div> */}
                  <div style={{ paddingLeft: '48px' }}>{recipients.length} {pluralize('Partner', recipients.length)}</div>
                </div>
                <div className={`${classes.flexItem} centerText`}>{ parseInt((stats || {}).opens || 0, 10)}% opened</div>
                <div className={`${classes.flexItem} ${classes.messageRowDelivered}`}>{ parseInt((stats || {}).delivered || 0, 10)}% delivered</div>
              </div>}
              actAsExpander
              showExpandableButton
            />
            <CardText expandable className={classes.cardText}>
              <TextField
                hintText="Search for a partner"
                ref="partnerFilter"
                onChange={this._updateValue.bind(this, 'partnerFilter')}
                fullWidth
                className={classes.searchBox}
                underlineShow={false}
                hintStyle={ { marginLeft: '10px', fontSize: '12px' } }
                inputStyle={ {
                  border: '1px solid #00bcd4',
                  bottom: '-10px',
                  height: '28px',
                  paddingLeft: '10px',
                  fontSize: '12px',
                }}
              />
              {recipientsFormatted.slice(((currentPage - 1) * 5), ((currentPage - 1) * 5) + 5).map(e => {
                const maxEventTxt = txtReplace[e.maxEvent] || e.maxEvent;
                return {
                  ...e,
                  maxEventTxt: `${maxEventTxt.charAt(0).toUpperCase()}${maxEventTxt.substr(1)}`,
                };
              }).map((partner, i) => <Card key={`${partner.partnerName}-${i + (currentPage - 1) * 5}`}>
                <CardHeader
                  className={classes.headerContainer}
                  title={<div className={classes.partnerRow}>
                    <div className={`${classes.partnerRowPartnerInfo}`}>
                      <Avatar
                        {...(partner.partnerAvatar) ? ({ src: partner.partnerAvatar }) : {} }
                      >
                        {partner.avatarText}
                      </Avatar>
                      {
                        partner.partnerId ? (
                          <a
                            className={classes.partnerRowCompanyName}
                            target="_blank"
                            href={`${process.env.NEW_SYSTEM_URL}/partner-management/partner-details/${partner.partnerId}?jwt=${localStorage.getItem('jwt')}`}
                          >
                            {partner.partnerName}
                          </a>
                        ) : (
                          <div
                            className={classes.partnerRowCompanyName}
                          >
                            {partner.partnerName}
                          </div>
                        )
                      }
                    </div>
                    <div className={`${classes.partnerRowStatus} centerText`}>
                      <div>{icons[partner.maxEvent]('partnerRowStatusIcon') || undefined}</div>
                      <div>{partner.maxEventTxt}</div>
                    </div>
                    <div className={`${classes.partnerRowcontacts}`}>{partner.to.length} {pluralize('contact', partner.to.length)}</div>
                  </div>}
                  showExpandableButton
                />
                <CardText expandable className={classes.cardText}>
                  <div style={{ marginRight: '158px' }}>
                    {partner.to.map(contact => {
                      const maxEventTxt = txtReplace[contact.maxEvent] || contact.maxEvent;
                      return {
                        ...contact,
                        displayName: contact.email,
                        maxEventTxt: `${maxEventTxt.charAt(0).toUpperCase()}${maxEventTxt.substr(1)}`,
                      };
                    }).map((contact, contacti) => (
                      <div key={contacti} style={{ display: 'flex', flexWrap: 'nowrap' }}>
                        <div style={{ marginLeft: '52px', width: '350px' }}>{contact.displayName}</div>
                        <div className={`centerText`} style={{ marginLeft: '24px' }}>{icons[contact.maxEvent]('userRowStatusIcon') || undefined}{contact.maxEventTxt}</div>
                        <div className={classes.flexItem}>&nbsp;</div>
                      </div>))}
                  </div>
                  {
                    eventPriority[partner.maxEventFromDirectRecipient] <= 4 && eventPriority[partner.maxEvent] > 4 && (
                      <div style={{ marginTop: '24px', marginLeft: '48px', fontSize: '12px', fontStyle: 'italic' }}>
                        Note: some of the contacts for this partners have TourConnect account(s) and this message has been redirected to other users from the same account as notifications.
                      </div>
                    )
                  }
                </CardText>
              </Card>)}
              {recipientsFormatted.length > 5 ? <Pagination
                currentPage={currentPage}
                totalPages={Math.ceil(recipientsFormatted.length / 5)}
                goToPage={this.switchPage}
                noOfPagesToShow={5}
              /> : undefined }
            </CardText>
          </Card>
          <Card>
            <CardHeader
              className={classes.headerContainer}
              title={<div className={classes.cardHeader}>
              <div className={classes.titleStart}><div>Subject & Content</div></div>
              </div>}
              actAsExpander
              showExpandableButton
            />
            <CardText expandable className={classes.cardTextMessage}>
              <p className={classes.cardTextTitle}>{subject}</p>
              <p className={`message-div ${classes.messageBody}`} dangerouslySetInnerHTML={{ __html: body }}/>
              <div className={classes.fileAttachment}>
              {attachments
                .filter(file => file.source !== 'template' && file.source !== 'request')
                  .map((file, i) => <Chip
                    key={i}
                    onTouchTap={() => { this._handleFileClick(file.path); }}
                    className={classes.chip}
                    key={file.name}
                  >
                  <Avatar color="#616061" icon={<FontIcon className={`tc-icon-attach_file ${classes.attachmentIcon}`} />} />
                  {file.name}
                </Chip>)}
                {
                  attachments
                    .filter(file => file.source === 'request')
                    .map((request, i) => <Chip key={i}>
                      {
                        request.startDate
                          ? `${moment.utc(request.startDate).format('MMM DDD YYYY')}-${moment.utc(request.startDate).format('MMM DDD YYYY')} Rate Request`
                          : request.fallbackName
                      }
                    </Chip>)
                }
                {
                  attachments
                    .filter(file => file.source === 'template')
                    .map((template, i) => <Chip key={i}>
                      {
                        template.locationName
                          ? `${template.locationName}-${template.templateName}`
                          : template.templateName
                      }
                    </Chip>)
                }
              </div>
            </CardText>
          </Card>
          <LoadingOverlay
            loading={conversationsFetching}
            style={{
              position: 'absolute',
              backgroundColor: 'rgba(0, 0, 0, 0.4)',
            }}
          />
        </div>
      </div>
    );
  }
}

massMessagingBody.propTypes = {
  bulkMessage: PropTypes.object,
  classes: PropTypes.object,
  conversationsFetching: PropTypes.bool,
  handleConfirm: PropTypes.func,
  howMany: PropTypes.number,
  title: PropTypes.string,
  selectedChannel: PropTypes.string,
  resendBulkMessage: PropTypes.func,
};

massMessagingBody.defaultProps = {
  handleConfirm: () => { console.log('confirmed'); },
  howMany: 0,
  bulkMessage: { recipients: [], title: ' ' },
};


const select = (state) => ({
  bulkMessage: state.workspace.conversations[0],
  title: state.workspace.conversationsTitle,
  conversationsFetching: state.workspace.conversationsFetching,
  selectedChannel: state.workspace.selectedChannel,
  isAnAdmin: state.user.get('isAnAdmin'),
});

export default connect(select, {
  routerPush,
  resendBulkMessage: payload => ({ type: 'ADMIN_RESEND_BULK_MESSAGE', payload }),
})(injectSheet(massMessagingBody));



// WEBPACK FOOTER //
// ./src/app/components/massmessaging/workspace/body.jsx